import React from 'react';

import { Container, Label, SupportText } from '../InformationBlocks.styled';

export interface Props {
    entryRequirement: string;
}

const EntryRequirement: React.FC<Props> = props => {
    const { entryRequirement } = props;

    return (
        <Container>
            <Label>
                Entry requirements: <strong>{entryRequirement}</strong>
            </Label>
            <SupportText>Or higher</SupportText>
        </Container>
    );
};

export default EntryRequirement;
